<div>
    <div class="content">
        <list-view [liste]="contratListView" *ngIf="contratListView"></list-view>
    </div>
    <floating-button *ngIf="listeActions?.value" [listeActions]="listeActions"></floating-button>
</div>